import {useState} from "react";
import {fetchMakers, fetchModels, fetchMotorcycles, fetchTypes} from "../api/apiService";
import {
    IMotorcycleFilterParams,
    IResponseMotorcycleList,
    IVehicleMaker,
    IVehicleModel,
    IVehicleType,
} from "../interfaces/Interfaces";

export const useDataFetching = () => {
    const [makers, setMakers] = useState<IVehicleMaker[]>([]);
    const [models, setModels] = useState<IVehicleModel[]>([]);
    const [types, setTypes] = useState<IVehicleType[]>([]);
    const [motorcycles, setMotorcycles] = useState<IResponseMotorcycleList | null>(null);
    const [selectedMaker, setSelectedMaker] = useState<number | null>(null);
    const [selectedModel, setSelectedModel] = useState<number | null>(null);
    const [selectedType, setSelectedType] = useState<number | null>(null);
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const [filtersLoading, setFiltersLoading] = useState<boolean>(false);

    const loadMakersAndTypes = async () => {
        setFiltersLoading(true);
        try {
            const [makerData, typeData] = await Promise.all([fetchMakers(), fetchTypes()]);
            setMakers(makerData);
            setTypes(typeData);
        } catch (error) {
            console.error("Error loading makers or types:", error);
        } finally {
            setFiltersLoading(false);
        }
    };

    const loadModels = async (makerId: number) => {
        if (!makerId) return;
        setFiltersLoading(true);
        try {
            const modelData = await fetchModels(makerId);
            setModels(modelData);
        } catch (error) {
            console.error("Error loading models:", error);
        } finally {
            setFiltersLoading(false);
        }
    };

    const loadMotorcycles = async (filters: IMotorcycleFilterParams) => {
        setDataLoading(true);
        try {
            const motorcycleData = await fetchMotorcycles(filters);
            setMotorcycles(motorcycleData);
        } catch (error) {
            console.error("Error fetching motorcycles:", error);
        } finally {
            setDataLoading(false);
        }
    };

    const resetFilters = () => {
        setSelectedMaker(null);
        setSelectedModel(null);
        setSelectedType(null);
    };

    return {
        makers,
        models,
        types,
        motorcycles,
        selectedMaker,
        selectedModel,
        selectedType,
        filtersLoading,
        dataLoading,
        loadMakersAndTypes,
        loadModels,
        loadMotorcycles,
        resetFilters,
        setModels,
        setSelectedMaker,
        setSelectedModel,
        setSelectedType,
    };
};
